import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { ProfileTypes } from '@sda/enums';
import type { Invitation } from '@sda/interfaces/invitation';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startAcceptInvitation = createAction<string>(`${Reducers.INVITATIONS}/startAcceptInvitation`);
export const startCreateInvitation = createAction<{ profileId: string, profileType: ProfileTypes, email: string }>(`${Reducers.INVITATIONS}/startCreateInvitation`);
export const startCreateShowInvitation = createAction<{ showId: string, email: string }>(`${Reducers.INVITATIONS}/startCreateShowInvitation`);
export const startFetchInvitation = createAction<string>(`${Reducers.INVITATIONS}/startFetchInvitation`);
export const startRemoveInvitation = createAction<string>(`${Reducers.INVITATIONS}/startRemoveInvitation`);
export const startResendInvitation = createAction<string>(`${Reducers.INVITATIONS}/startResendInvitation`);
export const startRevokeCollaborator = createAction<{ profileId: string, profileType: ProfileTypes, userId: string }>(`${Reducers.INVITATIONS}/startRevokeCollaborator`);

export const startWatchInvitations = createAction<string>(`${Reducers.INVITATIONS}/startWatchInvitations`);
export const unsubscribeInvitations = createAction<string>(`${Reducers.INVITATIONS}/unsubscribeInvitations`);

export const invitationAdapter = createEntityAdapter<Invitation & FetchDataType>();

const invitationsSlice = createSlice({
  initialState: invitationAdapter.getInitialState(),
  name: Reducers.INVITATIONS,
  reducers: {
    ...extractSharedActions(invitationAdapter),
  },
});

export const {
  addOne: addInvitation, removeOne: removeInvitation, updateOne: updateInvitation,
} = invitationsSlice.actions;

export default invitationsSlice.reducer;
